// src/pages/DevelopersPage.tsx — Site officiel Vanessa : hub développeurs
import { Rocket, BookOpen, KeyRound, Activity, Wallet, Gauge } from 'lucide-react';
import { Section, Grid, FeatureCard, CtaBand, PageHeader, CodeBlock, Steps } from '@/components/site/blocks';
import { buttonClasses } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { VANESSA_API_URL } from '@/api/constants';

export default function DevelopersPage() {
    const { isAuthenticated } = useAuth();
    const apiUrl = VANESSA_API_URL || 'https://api.kinemaplus.com';

    return (
        <>
            <PageHeader
                eyebrow="Développeurs"
                title="Intégrez Vanessa dans votre site ou votre application."
                intro="Une seule requête HTTP suffit : vous envoyez une conversation, Vanessa répond avec son ton et ses garde-fous."
            >
                <Link to="/developpeurs/demarrage" className={buttonClasses('primary', 'lg')}>Démarrage rapide</Link>
                <Link to={isAuthenticated ? '/console' : '/inscription'} className={buttonClasses('secondary', 'lg')}>
                    {isAuthenticated ? 'Ouvrir ma console' : 'Créer un compte'}
                </Link>
            </PageHeader>

            <Section title="Une requête, une réponse">
                <div className="grid items-start gap-8 lg:grid-cols-2">
                    <CodeBlock label="cURL">{`curl ${apiUrl}/v1 \\
  -H "x-api-key: cp_live_votre_cle" \\
  -H "Content-Type: application/json" \\
  -d '{"messages":[{"role":"user","content":"Salut Vanessa !"}]}'`}</CodeBlock>
                    <Steps
                        items={[
                            { title: 'Créez un compte', text: 'Le même compte que pour l’application Vanessa.' },
                            { title: 'Demandez une clé', text: 'Depuis la console, proposez un volume de tokens.' },
                            { title: 'Appelez l’API', text: 'Une fois la clé activée, elle ne s’affiche qu’une seule fois : copiez-la.' },
                        ]}
                    />
                </div>
            </Section>

            <Section tone="sand" title="Tout ce qu’il faut">
                <Grid cols={3}>
                    <FeatureCard icon={Rocket} title="Démarrage rapide" to="/developpeurs/demarrage" linkLabel="Première requête">
                        Votre première réponse de Vanessa en cinq minutes, en cURL, JavaScript ou Python.
                    </FeatureCard>
                    <FeatureCard icon={BookOpen} title="Documentation" to="/documentation" linkLabel="Lire la référence">
                        Format des requêtes, champ context, historique, limites et erreurs.
                    </FeatureCard>
                    <FeatureCard icon={Wallet} title="Tarifs" to="/tarifs" linkLabel="Voir comment ça marche">
                        Pas d’abonnement forcé : vous proposez un montant pour un volume de tokens.
                    </FeatureCard>
                    <FeatureCard icon={KeyRound} title="Console" to="/console" linkLabel="Gérer mes clés">
                        Demandez, suivez et rechargez vos clés API, et consultez votre quota restant.
                    </FeatureCard>
                    <FeatureCard icon={Activity} title="Statut" to="/statut" linkLabel="Voir l’état du service">
                        L’état de l’API en temps réel.
                    </FeatureCard>
                    <FeatureCard icon={Gauge} title="Limites">
                        20 requêtes par minute et par clé. Réponses de 300 tokens par défaut, 1024 au maximum.
                    </FeatureCard>
                </Grid>
            </Section>

            <CtaBand
                title="Vous êtes un média, une association, une institution ?"
                text="Des volumes peuvent être offerts dans le cadre d’un partenariat."
                primary={{ label: 'Découvrir les partenariats', to: '/entreprises' }}
            />
        </>
    );
}
